import React from 'react';
import { Modal, Form, Input, Button, message, Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import { addKnowledgeDatabase } from '../KnowledgeDatabaseServices';
import { useGlobal } from '../../Shared/GlobalContext/GlobalContext';

const AddKnowledgeBaseModal = ({ visible, onClose, navigate }) => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const { loading, setLoading } = useGlobal();

    const handleAddKnowledgeBase = async (values) => {
        try {
            setLoading(true);
            const response = await addKnowledgeDatabase(values);

            if (response.success) {
                message.success(t('knowledge_base_created_successfully'));
                onClose();
                form.resetFields();
                navigate(`/knowledge-base/${response.data.id}`);
            } else {
                message.error(response.message || t('failed_to_create_knowledge_base'));
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || t('error_creating_knowledge_base');
            message.error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title={t('add_knowledge_base')}
            open={visible}
            onCancel={() => {
                onClose();
                form.resetFields();
            }}
            footer={null}
            centered
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={handleAddKnowledgeBase}
                requiredMark="optional"
            >
                <Form.Item
                    name="name"
                    label={t('name')}
                    rules={[{ required: true, message: t('please_enter_knowledge_base_name') }]}
                >
                    <Input placeholder={t('enter_knowledge_base_name')} />
                </Form.Item>

                <Form.Item
                    name="description"
                    label={t('description')}
                >
                    <Input.TextArea
                        placeholder={t('enter_knowledge_base_description')}
                        rows={4}
                    />
                </Form.Item>

                <Form.Item className="mb-0">
                    <Button 
                        block 
                        type="primary" 
                        htmlType="submit" 
                        loading={loading}
                    >
                        {t('create')}
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default AddKnowledgeBaseModal;
